<div class="bg-(--toolbar-color) text-(--toolbar-text-color) h-[50px] flex items-center">
  <div class="w-full max-w-6xl mx-auto px-4 flex items-center">
    <a routerLink="/" class="flex flex-row items-center space-x-1" aria-label="Back to projects" i18n-aria-label>
      <mat-icon class="size-fit! text-base! text-inherit!">arrow_back</mat-icon>
      <span class="text-base italic" i18n>back to project dashboard</span>
    </a>
  </div>
</div>

<div class="w-full max-w-6xl mx-auto px-4 flex flex-col text-(--brand-text)">
  <div class="flex flex-row items-center space-x-1 py-6 border-b-1 border-solid border-(--hr-color)">
    <span class="text-2xl font-semibold">{{ project().name }}</span>
    @if (permissions.canModify()) {
    <a [routerLink]="['rename']" [state]="{ showLoading: false }">
      <mat-icon class="size-fit! text-base! text-inherit!" aria-hidden="true"
        fontSet="material-symbols-outlined">library_add_check</mat-icon>
    </a>
    }
    <span class="grow"></span>
    <mat-icon [class.active]="project().isActive" class="size-fit! text-base!" aria-hidden="true"
      fontSet="material-symbols-outlined">circle</mat-icon>
    <span class="">{{ project().isActive ? 'Active' : 'Draft' }}</span>
  </div>
  <div [class.hidden]="participantCount() < 1" class="mb-8">
    <span class="text-base font-semibold p-1">Participant Status</span>
    <div class="grid border-1 border-solid border-(--hr-color) space-1 p-8">
      <span class="border-b-1 border-solid border-(--hr-color) mb-4 pb-4">
        <a [routerLink]="['participants']" class="flex flex-row items-center space-x-1 size-fit">
          <span class="text-2xl font-semibold">{{ participantCount() }} Participants</span>
          <mat-icon fontSet="material-symbols-outlined" class="text-inherit! size-fit! text-base">last_page</mat-icon>
        </a>
      </span>
      <span class="flex flex-row items-center">
        @if (hasAssignedReports() && permissions.canModify()) {
        <a class="bg-(--brand-button-active-fill)! mr-2! px-4! h-8!" matButton="filled" i18n-aria-label
          aria-label="Invite Participants" [routerLink]="['invite']" [relativeTo]="this.route"
          [state]="{ showLoading: false }">
          Invite Participants
        </a>
        <a class="bg-(--brand-button-primary-fill)! mr-2! px-4! h-8!" matButton="filled" i18n-aria-label
          aria-label="Generate IDs" [routerLink]="['generate-ids']" [relativeTo]="this.route"
          [state]="{ showLoading: false }">
          Generate IDs
        </a>
        }
        @if (unclaimedIdsCount() > 0 && permissions.canModify()) {
        <button class="bg-(--brand-button-primary-fill)! mr-2! px-4! h-8!" matButton="filled" type="button"
          i18n-aria-label aria-label="Download unused IDs" (click)="downloadUnclaimedIds()">
          Download Unused IDs {{ unclaimedIdsCount() }}
        </button>
        }
      </span>
    </div>
  </div>
  <div [class.hidden]="participantCount() > 0" class="relative">
    <!-- Decorative. The overlay below is only tall enough to sit inside this
         image from lg up; at phone widths the image scales down well below the
         overlay's height, so it is dropped and the content flows normally
         instead of spilling onto the Reports section. -->
    <img src="assets/images/peoples.png" class="hidden lg:block w-full" />
    <span
      class="flex flex-col items-center gap-6 justify-center py-10 text-center lg:py-0 lg:absolute lg:-inset-px">
      <span class="flex flex-row flex-wrap justify-center items-center gap-y-2 lg:mt-[100px]">
        @if (hasAssignedReports() && permissions.canModify()) {
        <a class="bg-(--brand-button-active-fill)! mr-2! px-4! h-8!" matButton="filled" i18n-aria-label
          aria-label="Invite Participants" [routerLink]="['invite']" [relativeTo]="this.route"
          [state]="{ showLoading: false }">
          Invite Participants
        </a>
        <a class="bg-(--brand-button-primary-fill)! mr-2! px-4! h-8!" matButton="filled" i18n-aria-label
          aria-label="Generate IDs" [routerLink]="['generate-ids']" [relativeTo]="this.route"
          [state]="{ showLoading: false }">
          Generate IDs
        </a>
        }
        @if (unclaimedIdsCount() > 0 && permissions.canModify()) {
        <button class="bg-(--brand-button-primary-fill)! mr-2! px-4! h-8!" matButton="filled" type="button"
          i18n-aria-label aria-label="Download unused IDs" (click)="downloadUnclaimedIds()">
          Download Unused IDs {{ unclaimedIdsCount() }}
        </button>
        }
      </span>
      @if (hasAssignedReports()) {
      <span class="font-semibold">you must add participants to get your project started</span>
      } @else {
      <span class="font-semibold">you must assign a report to this project before adding participants</span>
      }
    </span>
  </div>
  <span class="text-base font-semibold p-1 pt-2 border-t-1 border-t-(--hr-color) border-t-solid">Reports</span>
  <div class="grid grid-cols-[repeat(auto-fill,150px)] gap-8 place-items-center">
    @for (report of projectReports(); track $index) {
    <div class="flex flex-col w-[150px]">
      <span class="text-sm bg-black text-white p-1 h-[55px] text-ellipsis text-nowrap overflow-hidden">{{ report.name
        }}</span>
      <img src="assets/images/reports/{{ report.id }}.png" class="max-w-full"
        appImageFallback="assets/images/reports/Custom.png" loading="lazy" decoding="async" alt="{{ report.name }}" />
      @if (permissions.canModify()) {
      <div class="flex flex-row justify-between p-2 bg-(--hr-color)">
        <span class="text-base">Settings</span>
        <a routerLink="./reports/{{ report.id }}">
          <mat-icon class="text-inherit! size-fit! text-base!">settings</mat-icon>
        </a>
      </div>
      }
      <div class="flex flex-col p-2 bg-(--report-settings-light)">
        <span class="flex flex-row space-x-1 items-center min-w-0">
          <mat-icon class="text-inherit! size-fit! text-base! flex-none">language</mat-icon>
          <span class="text-sm truncate" [title]="report.language | localeName">{{ report.language | localeName
            }}</span></span>
        <span class="flex flex-row space-x-1 items-center min-w-0">
          <mat-icon fontSet="material-symbols-outlined"
            class="text-inherit! size-fit! text-base! flex-none">globe</mat-icon>
          <span class="text-sm truncate" [title]="report.norm">{{ report.norm }}</span>
        </span>
        @if (report.jobProfile) {
        <span class="flex flex-row space-x-1 items-center min-w-0">
          <mat-icon fontSet="material-symbols-outlined"
            class="text-inherit! size-fit! text-base! flex-none">work</mat-icon>
          <span class="text-sm truncate" [title]="report.jobProfile">{{ report.jobProfile }}</span>
        </span>
        }
      </div>
    </div>
    }

    @for (pkg of projectPackages(); track $index) {
    <div class="flex flex-col w-[150px]">
      <span class="text-sm bg-black text-white p-1 h-[55px] text-ellipsis text-nowrap overflow-hidden">{{ pkg.name
        }}</span>
      <img src="assets/images/reports/Package.png" class="max-w-full"
        appImageFallback="assets/images/reports/Custom.png" loading="lazy" decoding="async" alt="{{ pkg.name }}" />
      @if (permissions.canModify()) {
      <div class="flex flex-row justify-between p-2 bg-(--hr-color)">
        <span class="text-base">Settings</span>
        <a routerLink="./reports/{{ pkg.id }}">
          <mat-icon class="text-inherit! size-fit! text-base!">settings</mat-icon>
        </a>
      </div>
      }
      <div class="flex flex-col p-2 bg-(--report-settings-light)">
        <span class="flex flex-row space-x-1 items-center min-w-0">
          <mat-icon class="text-inherit! size-fit! text-base! flex-none">language</mat-icon>
          <span class="text-sm truncate" [title]="pkg.language | localeName">{{ pkg.language | localeName
            }}</span></span>
        <span class="flex flex-row space-x-1 items-center min-w-0">
          <mat-icon fontSet="material-symbols-outlined"
            class="text-inherit! size-fit! text-base! flex-none">globe</mat-icon>
          <span class="text-sm truncate" [title]="pkg.norm">{{ pkg.norm }}</span>
        </span>
        @if (pkg.jobProfile) {
        <span class="flex flex-row space-x-1 items-center min-w-0">
          <mat-icon fontSet="material-symbols-outlined"
            class="text-inherit! size-fit! text-base! flex-none">work</mat-icon>
          <span class="text-sm truncate" [title]="pkg.jobProfile">{{ pkg.jobProfile }}</span>
        </span>
        }
      </div>
    </div>
    }

    @if (permissions.canModify()) {
    <button matButton="filled" class="size-fit bg-(--brand-button-primary-fill)! h-8!" i18n-aria-label
      aria-label="edit reports" routerLink="reports">
      Edit Reports
    </button>
    }
  </div>
  <span
    class="text-base font-semibold p-1 pt-2 mt-8 border-t-1 border-t-(--hr-color) border-t-solid">Notifications</span>
  <span class="text-sm p-1">Reports will be sent to the following addresses as they become available.</span>
  <div class="w-full max-w-xl">
    <span [hidden]="project().email1 == null" class="w-full flex flex-row items-center gap-5">
      <mat-form-field class="w-full email-notification-field">
        <mat-label>Email Address</mat-label>
        <input matInput [value]="project().email1" placeholder="Enter an email address"
          [readonly]="!permissions.canModify()" />
      </mat-form-field>
      @if (permissions.canModify()) {
      <button class="bg-(--brand-button-primary-fill)! mr-2! px-4! h-8!" matButton="filled" type="button"
        i18n-aria-label aria-label="Remove notification email" (click)="removeNotificationEmail(1)">
        Remove
      </button>
      } </span>
    <span [hidden]="project().email2 == null" class="w-full flex flex-row items-center gap-5">
      <mat-form-field class="w-full email-notification-field">
        <mat-label>Email Address</mat-label>
        <input matInput [value]="project().email2" placeholder="Enter an email address"
          [readonly]="!permissions.canModify()" />
      </mat-form-field>
      @if (permissions.canModify()) {
      <button class="bg-(--brand-button-primary-fill)! mr-2! px-4! h-8!" matButton="filled" type="button"
        i18n-aria-label aria-label="Remove notification email" (click)="removeNotificationEmail(2)">
        Remove
      </button>
      } </span>
    <span [hidden]="project().email3 == null" class="w-full flex flex-row items-center gap-5">
      <mat-form-field class="w-full email-notification-field">
        <mat-label>Email Address</mat-label>
        <input matInput [value]="project().email3" placeholder="Enter an email address"
          [readonly]="!permissions.canModify()" />
      </mat-form-field>
      @if (permissions.canModify()) {
      <button class="bg-(--brand-button-primary-fill)! mr-2! px-4! h-8!" matButton="filled" type="button"
        i18n-aria-label aria-label="Remove notification email" (click)="removeNotificationEmail(3)">
        Remove
      </button>
      } </span>
    <span [hidden]="project().email4 == null" class="w-full flex flex-row items-center gap-5">
      <mat-form-field class="w-full email-notification-field">
        <mat-label>Email Address</mat-label>
        <input matInput [value]="project().email4" placeholder="Enter an email address"
          [readonly]="!permissions.canModify()" />
      </mat-form-field>
      @if (permissions.canModify()) {
      <button class="bg-(--brand-button-primary-fill)! mr-2! px-4! h-8!" matButton="filled" type="button"
        i18n-aria-label aria-label="Remove notification email" (click)="removeNotificationEmail(4)">
        Remove
      </button>
      } </span>
    @if (permissions.canModify()) {
    <span
      [hidden]="project().email4 != null && project().email3 != null && project().email2 != null && project().email1 != null"
      class="w-full flex flex-row items-center gap-5">
      <mat-form-field class="w-full email-notification-field">
        <mat-label>Email Address</mat-label>
        <input matInput placeholder="Enter an email address" [value]="addNotificationEmail()"
          (input)="onAddNotificationEmailInput($any($event.target).value)" />
      </mat-form-field>
      <button class="bg-(--brand-button-primary-fill)! mr-2! px-4! h-8!" matButton="filled" type="button"
        i18n-aria-label aria-label="Add notification email" (click)="addNotificationEmailClick()">
        Add
      </button> </span>
    }
  </div>
</div>
<router-outlet></router-outlet>